/*
首页接口
*/
import request from '@/utils/request'

//获取首页左上角信息
export function getHomeDetail() {
  return request({
    method: "get",
    url: "/yzdservice/enterprise/yzddw/getGztDwxx"
  });
}
///api/news/info/{newsId}
//获取首页左上角信息
export function getNewsDetail(newsId) {
  return request({
    method: "get",
    url: `/yzdservice/api/news/info/${newsId}`
  });
}

export function validPassword() {
  return request({
    url: process.env.VUE_APP_BASE_API + '/organization/api/info/valid/password',
    method: 'GET'
  }
  )
}
